import styled, { keyframes } from 'styled-components';
import '../../styles/opensans.less';
import { NOC_MODE_FILTERS } from '@utils/constants';

const topPanelMarginOnMode = (mode) => {
  if (mode === NOC_MODE_FILTERS) {
    return 0;
  }
  return '5px';
};

const summaryMarginOnMode = (mode) => {
  if (mode === NOC_MODE_FILTERS) {
    return 0;
  }
  return '20px';
};

export const NocWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  position: relative;
  height: calc(100% - 20px);
  align-items: center;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  background-color: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ScopeWrapper = styled.div`
  float: left;
  margin: 45px 10px 20px 20px;
`;

export const TopPanelWrapper = styled.div`
  margin-bottom: ${({ mode }) => topPanelMarginOnMode(mode)};
  background-color: #fff;
  position: relative;
  width: 100%;
`;

export const TabWrapper = styled.div`
  position: absolute;
  width: 100%;
`;

export const WrapHeaderTitle = styled.span`
  h2 {
    font-size: 14px;
    white-space: normal;
    font-weight: 500;
    margin: 0;
    line-height: 0.9;
    position: relative;
    display: inline-block;
    color: #17253a;

    .noc-title-holder {
      cursor: pointer;
      margin: 0.1rem 0 0.2rem;
      display: block;
      position: relative;
      white-space: normal;

      .noc-title {
        display: block;
        margin: 0 auto;
        max-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f2f2f2;
        padding: 0 0.5rem 0.2rem 10px;
        max-width: 600px;
        overflow-x: hidden;
        min-height: 32px;
        white-space: normal;
        line-height: 16px;

        &:hover {
          outline: 1px solid #ccc;
        }
      }

      &:focus {
        outline: none;
      }

      .vertical-bar {
        position: absolute;
        width: 0.3rem;
        top: 0;
        left: 0;
        bottom: 0;
        background: #bd10e0;
        z-index: 1;
      }
    }
  }
`;

export const Delimiter = styled.span`
  color: #215bff;
  padding: 0 0.25rem;
`;

export const SummaryWrapper = styled.div<{ $mode?: string }>`
  position: relative;
  display: flex;
  margin-top: 45px;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: ${({ $mode }) => summaryMarginOnMode($mode)};
  margin-right: 20px;
`;

export const FilterWrapper = styled.div`
  @media (min-width: 900px) {
    max-width: 800px;
  }

  border: 1px solid #17253a;
  width: 800px;
  background-color: #fff;
  position: absolute;
  padding: 1rem;
  box-shadow: 0 0 4px -1px rgb(0 0 0 / 30%);
  border-radius: 3px;

  & .ant-dropdown-menu-item-disabled .ant-dropdown-menu-submenu-title-disabled {
    background: none !important;
  }

  & .ant-tabs-tab {
    margin: 0 5px 5px 0 !important;
    background-color: #fff !important;
  }

  & .ant-tabs-tab-active {
    color: #0046ff !important;
    background-color: #e9f3fd !important;
  }

  & .ant-collapse-content-box > div:hover {
    background-color: #e9f3fd !important;
  }

  & .ant-select-selector {
    background-color: #fff !important;

    .ant-select-selection-item {
      background-color: #e9f3fd !important;
    }
  }

  & .ant-checkbox-wrapper:hover {
    background-color: #f6f6f6 !important;
  }

  & div[class^='filter-pill'] .ant-checkbox-wrapper-checked {
    background-color: #e9f3fd !important;
    border-color: #215bff !important;
  }

  & .ant-checkbox-inner {
    background: none !important;
  }

  & .ant-checkbox-inner::after {
    border-color: #1890ff !important;
  }

  & .ant-select-selection {
    max-height: 85px;
    overflow: auto;
  }

  & .ant-tabs-extra-content a {
    color: #1890ff !important;
  }

  & .ant-select-dropdown {
    background-color: #fff !important;
    border: 1px solid #ddd !important;

    i svg path {
      color: #fff !important;
    }

    & .ant-select-item-option-selected,
    & .ant-select-item-option-active {
      background-color: #e9f3fd !important;

      i svg path {
        color: #17253a !important;
      }
    }
  }
`;

export const ModalMask = styled.div`
  position: fixed;
  inset: 0;
  opacity: 0.7;
  opacity: var(--modal-opacity, 0.7);
  z-index: 70;
  background-color: rgb(0 0 0);
  background-color: var(--model-background, rgb(0 0 0));

  & + div {
    z-index: 71;
  }
`;

export const ThresholdHeader = styled.div`
  font-size: 20px;
  margin: 37px 20px 20px;
  float: left;
`;

const blink = keyframes`
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
`;

export const TimeTablet = styled.div`
  padding: 6px 10px;
  min-width: 200px;
  text-align: left;
  border: 1px solid #d9d9d9;
  color: #4a4a4a;
  border-radius: 5px;
  font-weight: 500;
  font-size: 16px;

  & .loading-time span {
    animation-name: ${blink};
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
`;

export const CheckerPanel = styled.div`
  margin: 8px;
  height: 100%;
`;
